import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var contentAccess = new GatewayService('content-access');

var getStates = function getStates(componentBusinessKeys, sectionBusinessKeys, studentBusinessKeys) {
  var reqBody = {
    componentBusinessKeys: componentBusinessKeys,
    sectionBusinessKeys: sectionBusinessKeys,
    studentBusinessKeys: studentBusinessKeys
  }; // note that we are no longer requesting the audio access state here
  // that now happens via 'fetchStudentAudioAccessState' in 'storage.js'

  return contentAccess.post('componentState/islocked', reqBody);
};

var lockStudent = function lockStudent(componentBusinessKeys, sectionBusinessKeys, studentBusinessKeys, cardstackBusinessKeys) {
  var reqBody = {
    componentBusinessKeys: componentBusinessKeys,
    sectionBusinessKeys: sectionBusinessKeys,
    studentBusinessKeys: studentBusinessKeys,
    cardstackBusinessKeys: cardstackBusinessKeys
  };
  return contentAccess.post("componentState/student/lock", reqBody);
};

var unlockStudent = function unlockStudent(componentBusinessKeys, sectionBusinessKeys, studentBusinessKeys, cardstackBusinessKeys) {
  var reqBody = {
    componentBusinessKeys: componentBusinessKeys,
    sectionBusinessKeys: sectionBusinessKeys,
    studentBusinessKeys: studentBusinessKeys,
    cardstackBusinessKeys: cardstackBusinessKeys
  };
  return contentAccess.post("componentState/student/unlock", reqBody);
};

var lockStudentAudio = function lockStudentAudio(componentBusinessKeys, sectionBusinessKeys, studentBusinessKeys, cardstackBusinessKeys) {
  var reqBody = {
    componentBusinessKeys: componentBusinessKeys,
    sectionBusinessKeys: sectionBusinessKeys,
    studentBusinessKeys: studentBusinessKeys,
    cardstackBusinessKeys: cardstackBusinessKeys
  };
  return contentAccess.post("componentState/student/lockAudio", reqBody);
};

var unlockStudentAudio = function unlockStudentAudio(componentBusinessKeys, sectionBusinessKeys, studentBusinessKeys, cardstackBusinessKeys) {
  var reqBody = {
    componentBusinessKeys: componentBusinessKeys,
    sectionBusinessKeys: sectionBusinessKeys,
    studentBusinessKeys: studentBusinessKeys,
    cardstackBusinessKeys: cardstackBusinessKeys
  };
  return contentAccess.post("componentState/student/unlockAudio", reqBody);
};

var setRosterOrder = function setRosterOrder(roster) {
  return _.orderBy(_.uniqBy(roster, 'sourcedId'), [function (student) {
    return student.familyName === null ? '' : student.familyName.toLowerCase();
  }, function (student) {
    return student.givenName === null ? '' : student.givenName.toLowerCase();
  }], ['asc']);
};

var getRosterAccessState = function getRosterAccessState(roster, classSourcedId, lessonKey) {
  var students = setRosterOrder(roster).map(function (student) {
    return Object.assign(student, {
      isLocked: true
    });
  });
  var studentIds = students.map(function (student) {
    return student.sourcedId;
  });
  return getStates([lessonKey], [classSourcedId], studentIds).then(function (componentStates) {
    return students.map(function (student) {
      var stateObj = _.find(componentStates, {
        studentBusinessKey: student.sourcedId
      });

      if (stateObj) {
        var stateIsLocked = function stateIsLocked() {
          return stateObj.state === 'unlocked' && stateObj.value === 'false';
        };

        Object.assign(student, {
          isLocked: stateIsLocked()
        });
      }

      return student;
    });
  });
};

var getStudentAccessState = function getStudentAccessState(lessonKey, classSourcedIds, studentSourcedId) {
  return getStates([lessonKey], classSourcedIds, [studentSourcedId]);
};

export default {
  getStates: getStates,
  getRosterAccessState: getRosterAccessState,
  getStudentAccessState: getStudentAccessState,
  lockStudent: lockStudent,
  unlockStudent: unlockStudent,
  lockStudentAudio: lockStudentAudio,
  unlockStudentAudio: unlockStudentAudio
};